/* src/app/modules/ct-status/components/cts-gantry-log-empty-state/cts-gantry-log-empty-state.component.scss */
:host {
  display: flex;
  padding: 240px 86px;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  background: rgba(0, 0, 0, 0.05);
}
/*# sourceMappingURL=cts-gantry-log-empty-state.component.css.map */
